var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_794",
    "data-name": "Group 794",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.391,
    height: 33.391,
    viewBox: "0 0 33.391 33.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    y2: 33.391,
    transform: "translate(16.695)",
    fill: "none",
    stroke: "#1583dd",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y2: 33.391,
    transform: "translate(33.391 16.695) rotate(90)",
    fill: "none",
    stroke: "#1583dd",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.3df9e71f.svg";
export { ForwardRef as ReactComponent };